import {Observable} from 'rxjs';
import {$httpClient} from '@/services/httpClient';
import {DELETE_DOCUMENT, DOCUMENTS_LIST, DOWNLOAD_DOCUMENT, UPLOAD_DOCUMENT} from '@/types/documents.types';
import {Documents} from '@/models/form/Documents.model';
import {InputFile} from '@/models/InputFile.model';

export default class DocumentService {
  private readonly baseApi: string;

  constructor() {
    this.baseApi = 'api/emp/docs/';
  }

  public uploadDocument(inputFile: InputFile, docType: string, formId: number): Observable<Documents> {
    const formData = new FormData();
    formData.append('files', inputFile.file);
    formData.append('docType', docType.slice(3));
    formData.append('docName', inputFile.name);
    formData.append('formId', formId.toString());
    return $httpClient.post<any>(this.baseApi + UPLOAD_DOCUMENT, formData);
  }

  public deleteDocument(docId: number) {
    return $httpClient.delete<any>(this.baseApi + DELETE_DOCUMENT + '?docId=' +  docId);
  }

  public getDocumentContent(docId: number) {
    return $httpClient.get<any>(this.baseApi + DOWNLOAD_DOCUMENT + '?docId=' + docId);
  }

  public getFormDocumentsList(formId: number) {
    return $httpClient.get<any>(this.baseApi + DOCUMENTS_LIST + '?formId=' + formId);
  }
}
